import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(manteinance_templates => ({
        value: manteinance_templates.id,
        label: manteinance_templates.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/maintenance-templates', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },

    clear({ commit }) {
      commit('setData', [])
    }
  },
}
